import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface ProtectedRouteProps {
    children: React.ReactNode;
    requiredRole?: 'admin' | 'user';
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
    children, 
    requiredRole = 'user' 
}) => {
    const { state, hasPermission } = useAuth();
    
    if (state.isLoading) {
        return <div>Loading...</div>; // You might want to use a proper loading spinner
    }
    
    if (!state.user) {
        return <Navigate to="/login" replace />;
    }
    
    if (!hasPermission(requiredRole)) {
        return <Navigate to="/" replace />;
    }
    
    return <>{children}</>;
};